<template>
<div class="upload-one-file-validate">
  <div class="add-img-btn-common">
    <div class="add-licence" v-if="choosenFile == null">添加</div>
    <input type="file" class="add-licence-input" ref="fileContainerId" @change="validateFileChange">
  </div>
  <div class="add-img-btn-common-name" v-if="choosenFile != null">
    <div class="pic-name">{{choosenFile.name}}
      <span class="close-icon" @click="deleteChoosenFile"></span>
    </div>
  </div>
  <div class="el-form-item__error" v-if="fileUploadError.length > 0">
    {{fileUploadError}}
  </div>
</div>

</template>

<script>
import MessageType from '@/components/common/message-box/MessageType';
const ALLOW_IMAGE_TYPE = {
  'image/jpeg': true,
  'image/png': true,
  'image/gif': true,
  'image/jpg': true,
  'application/pdf': true,
  'image/bmp': true
};
const IMGSIZE4M = 4 * 1024 * 1024;
const IMGSIZE20M = 20 * 1024 * 1024;
const INFOSIZE = 1 * 1024 * 1024;
const DEVICESIZE = 500 * 1024;
const INFOSIZE2M = 2 * 1024 * 1024;
const fileErrorInfo = {
  LICENCE: '请上传营业执照图片',
  CONTRACT: '请上传合同文件',
  COOPREAT: '请上传合作备案',
  HARDWARE: '请上传机器硬件信息文件',
  SIZE4M: '请上传4M以内大小的csv文件',
  FORMAT: '请上传jpg,png,gif,jpeg,bmp,pdf格式',
  FORMAT_CSV: '请上传csv格式',
  GROUPDEVICE: '请上传设备文件',
  INFO: '申请正式授权前请添加相关文件',
  DEVICE_INFO_ERROR: '请上传设备信息',
  DEVICE_INFO_SIZE: '请上传1M以内大小的文件',
  DEVICE_SIZE: '请上传500KB以内大小的文件',
  IMGSIZE_20M: '请上传20M以内大小的文件',
  INFOSIZE2M: '请上传2M以内大小的文件，可截图关键信息进行上传'
};
export default {
  data() {
    return {
      choosenFile: null,
      fileUploadError: ''
    };
  },
  watch: {
    validateFile: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.validateFileChange();
        }
      },
      deep: true
    },
    dialogVisible: {
      immediate: true,
      handler(newVal, oldVal) {
        this.choosenFile = null;
        this.fileUploadError = '';
        if (this.$refs.fileContainerId) {
          this.$refs.fileContainerId.value = null;
        }
      },
      deep: true
    }
  },
  props: ['ErrorName', 'NeedConfirm', 'validateFile', 'dialogVisible', 'hasFile', 'formatCSV', 'allFormatType', 'noValidate', 'twentyM', 'twoM'],
  methods: {
    validateFileChange() {
      if (!this.$refs.fileContainerId) {
        return;
      }
      let files = this.$refs.fileContainerId.files;
      if (files && files.length > 0) {
        this.choosenFile = files[0];
      }
      if (this.choosenFile == null) {
        this.fileUploadError = fileErrorInfo[this.ErrorName];
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.formatCSV === false && this.allFormatType === false && this.choosenFile.size > INFOSIZE) {
        this.fileUploadError = fileErrorInfo.DEVICE_INFO_SIZE;
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.formatCSV && this.choosenFile.size > IMGSIZE4M) {
        this.fileUploadError = fileErrorInfo.SIZE4M;
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.allFormatType && this.choosenFile.size > DEVICESIZE) {
        this.fileUploadError = fileErrorInfo.DEVICE_SIZE;
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.twentyM && this.choosenFile.size > IMGSIZE20M) {
        this.fileUploadError = fileErrorInfo.IMGSIZE_20M;
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.twoM && this.choosenFile.size > INFOSIZE2M) {
        this.fileUploadError = fileErrorInfo.INFOSIZE2M;
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.$emit('validateInfoResult', {result: false, file: null});
        return;
      }
      if (this.formatCSV) {
        if (this.choosenFile.type !== 'application/vnd.ms-excel' && this.choosenFile.type !== 'text/csv') {
          this.fileUploadError = fileErrorInfo.FORMAT_CSV;
          this.$refs.fileContainerId.value = null;
          this.choosenFile = null;
          this.$emit('validateInfoResult', {result: false, file: null});
          return;
        }
      } else if (this.allFormatType) {
        if (this.choosenFile.type == null) {
          this.fileUploadError = fileErrorInfo.DEVICE_INFO_ERROR;
          this.$refs.fileContainerId.value = null;
          this.choosenFile = null;
          this.$emit('validateInfoResult', {result: false, file: null});
          return;
        }
      } else {
        if (!ALLOW_IMAGE_TYPE[this.choosenFile.type]) {
          this.fileUploadError = fileErrorInfo.FORMAT;
          this.$refs.fileContainerId.value = null;
          this.choosenFile = null;
          this.$emit('validateInfoResult', {result: false, file: null});
          return;
        }
      }
      this.fileUploadError = '';
      this.$emit('validateInfoResult', {result: true, file: this.choosenFile});
    },
    deleteChoosenFile() {
      if (this.NeedConfirm === false) {
        this.$refs.fileContainerId.value = null;
        this.choosenFile = null;
        this.fileUploadError = fileErrorInfo[this.ErrorName];
        this.validateFileChange();
      } else {
        this.$confirm(`'确定删除"${this.choosenFile.name}"'`, '确认删除', MessageType.INFO).then(() => {
          this.$refs.fileContainerId.value = null;
          this.choosenFile = null;
          if (this.noValidate) {
            this.$emit('validateInfoResult', {result: false, file: null});
            return;
          }
          this.fileUploadError = fileErrorInfo[this.ErrorName];
          this.validateFileChange();
        });
      }
    },
    deleteUrlFile() {}
  }
};
</script>

<style lang="less" scoped>
.upload-one-file-validate{
  .add-img-btn-common{
    overflow: hidden;
    position: relative;
    .add-licence{
      display: inline-block;
      width: 70px;
      color: #636363;
      padding-left: 30px;
      background: url(../img/bt_plus_normal.png) no-repeat 0 center;
    }
    &:hover{
      .add-licence{
        background: url(../img/bt_plus_hover.png) no-repeat 0 center;
      }
    }
    .add-licence-input{
      display: block;
      cursor: pointer;
      opacity: 0;
      position: absolute;
      top: 0;
      left: -75px;
      bottom: 0;
      right: 0;
      width: 160px;
    }
  }
  .add-img-btn-common-name{
    .pic-name{
      color: #999999;
      background: url(../img/icon_buss_lic.png) no-repeat 0 center;
      padding-right: 12px;
      padding-left: 32px;
      .close-icon{
        cursor: pointer;
        padding-left: 12px;
        width: 12px;
        height: 12px;
        display: inline-block;
        background: url(../img/close_normal.png) no-repeat 12px center;
        &:hover{
          background: url(../img/close_hover.png) no-repeat 12px center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/common/FormItemUploadFile.vue